<!--
  ~ Copyright (C) 2026 - Potentially Ltd
  ~
  ~ Please see distribution for license.
  -->

@if (organizationData$ | async; as organizationData) {
  <main
    class="v3-main"
    [ngStyle]="{
      'background-image': organizationData.landingPage.backgroundImage
        ? 'url(&quot;' + organizationData.landingPage.backgroundImage + '&quot;)'
        : '',
      'background-color': organizationData.landingPage.useBackgroundColourFill ? organizationData.landingPage.backgroundColour : '',
    }"
    [class.dynamic-background-color]="organizationData.landingPage.useBackgroundColourFill"
    [class.split-screen]="organizationData.landingPage.layout === 'SPLIT_SCREEN'"
  >
    @if (showMaintenanceOverlay) {
      <div class="maintenance-layer">
        <div class="maintenance-layer-inner" [innerHTML]="'translations.maintenance.overlayText' | transloco"></div>
      </div>
    }

    <div class="v3-form-container" [class.split-screen]="organizationData.landingPage.layout === 'SPLIT_SCREEN'">
      <div class="v3-login-card" [class.split-screen]="organizationData.landingPage.layout === 'SPLIT_SCREEN'">
        <div class="v3-brand-row">
          <img
            class="v3-brand-logo"
            width="44"
            height="44"
            [src]="organizationData.landingPage.landingLogo || organizationData.logo"
            alt="{{ organizationData.name }} Logo"
          />
          <span class="v3-brand-name semibold">{{ organizationData.name }}</span>
        </div>

        <div class="v3-headline">
          <h1 class="v3-title">{{ organizationData.name }}</h1>
          <p class="v3-subtitle fs-body-m">{{ organizationData.landingPage.welcomeMessage }}</p>
        </div>

        <re-captcha #captchaElem [siteKey]="reCaptchaSiteKeyV2" (resolved)="proceedJoin($event)" size="invisible"></re-captcha>

        <div class="v3-actions">
          <ptl-sg-button type="flat" color="primary" class="v3-submit" [disabled]="!joinReady" (clicked)="onJoinButtonClick()">
            <span>{{ 'translations.public.button.join' | transloco }} {{ organizationData.name }}</span>
          </ptl-sg-button>
        </div>
      </div>
    </div>
  </main>
} @else {
  <div class="v3-loading-container">
    <div class="v3-loading-logo">
      <img src="https://static.yuna.potential.ly/public/images/icons/potentially_logo.png" alt="Potential.ly Logo" width="60" height="61" />
      <span class="section-title">{{ 'translations.public.lti.title.logoText' | transloco }}</span>
    </div>
    <div class="v3-loading-in-progress">
      <span class="fs-body-m">{{ 'translations.loginFormLoading.loading' | transloco }}</span>
      <mat-spinner [diameter]="25"></mat-spinner>
    </div>
    <div class="v3-loading-warning fs-body-s bold">{{ 'translations.loginFormLoading.loadingTooLongWarning' | transloco }}</div>
  </div>
}
